/*******************************************************************************
 * Copyright     : Copyright (c)  2025 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React, { useMemo } from "react";

//@Packages
import { useTranslation } from "react-i18next";
import DynamicForm from "../../form/DynamicForm";

//@Models
import { Next9ServiceDetailsProps, IFormData, FormElementType, IFormElementConfig } from "../../../../models/softwaredetails";

//@Styles
import "./index.scss";
import { SOFTWARE_CONSTANTS } from "../../../../utils/constants";

const NO_SPACES_PATTERN = /^\S*$/;

const Next9ServiceDetails: React.FC<Next9ServiceDetailsProps> = ({
  title,
  subTitle,
  config = {},
  onSubmit,
  onCancel,
  cancelEnabled = true,
  fieldProps = {},
  showWarningMessage = false,
  notificationProps
}) => {
  const { t } = useTranslation();

  const LICENSE_KEY = "licenseKey";
  const SITE_ID = "siteId";

  const checkIfFieldDisabled = (key: string) => {
    try {
      return fieldProps?.[key]?.disabled || false;
    } catch (error) {
      return false;
    }
  };

  // Handle form submission
  const handleFormSubmit = (formData: IFormData) => {
    if (onSubmit) {
      onSubmit(formData);
    }
  };

  // Handle cancel
  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

    // Build form configuration
  const formConfig: IFormElementConfig[] = useMemo(() => {
    return [
      {
        type: FormElementType.TEXT,
        id: LICENSE_KEY,
        label: "License Key",
        placeholder: "Enter License Key",
        value: config[LICENSE_KEY],
        disabled: checkIfFieldDisabled(LICENSE_KEY),
        validators: [
          {
            type: 'required',
            message: 'Cannot be blank'
          },
          {
            type: 'pattern',
            value: NO_SPACES_PATTERN,
            message: 'No Spaces Allowed'
          }
        ]
      },
      {
        type: FormElementType.TEXT,
        id: SITE_ID,
        label: "Site Id",
        placeholder: "Enter Site Id",
        value: config[SITE_ID],
        disabled: checkIfFieldDisabled(SITE_ID),
        validators: []
      }
    ];
  }, [config, fieldProps]);

  return (
    <DynamicForm
      title={title}
      subTitle={subTitle}
      config={formConfig}
      onSubmit={handleFormSubmit}
      onCancel={cancelEnabled ? handleCancel : undefined}
      submitLabel={SOFTWARE_CONSTANTS.install}
      cancelLabel={SOFTWARE_CONSTANTS.cancel}
      showWarningMessage={showWarningMessage}
      notificationProps={notificationProps}
    />
  );
};

export default Next9ServiceDetails;